import { Button, Tooltip, IconButton } from "@material-ui/core";
import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/products.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { BiEditAlt } from "react-icons/bi";
import TablePagination from "@material-ui/core/TablePagination";
import Global from "../global";
import { IoMdAddCircle } from "react-icons/io";
import { MdAdd } from "react-icons/md";

import { AiOutlineDelete } from "react-icons/ai";

import { useHistory } from "react-router";
import DeleteModal from "./DeleteModal";

import { IconContext } from "react-icons";

// import API from "../utills/api";
import Loader from "react-loader-spinner";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import emptyLabs from "../assets/images/empty-lab.png";
import { BsSliders } from "react-icons/bs";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Badge from "@material-ui/core/Badge";
import Popover from "@material-ui/core/Popover";
import { CgClose } from "react-icons/cg";

const useStyles = makeStyles({
  rootAbsolute: {
    position: "relative",
    fontFamily: "BoldFont",

    "& .MuiButton-startIcon": {
      position: "absolute",
      right: 0,
    },
    "& .MuiButton-label": {
      marginRight: 10,
      transition: "all 0.3s",
    },
  },
});

const Labs = () => {
  const history = useHistory();
  const classes = useStyles();
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  const config2 = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  };
  // console.log("AdminProduct", props);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [labTestAccess, setLabTestAccess] = useState();
  const [labPackageAccess, setLabPackageAccess] = useState();
  const [refresh, setRefresh] = useState("");
  const [labAccess, setLabAccess] = useState({});
  const [hospitalList, setHospitals] = useState([]);
  const [editHospital, setHospital] = useState({
    data: {},
    index: "",
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterData, setFilterData] = useState({});

  //filter states
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");

  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [paginationData, setPaginationData] = useState({});

  const filterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const filterClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleChangePage = (event, newPage) => {
    getLab(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    getLab(page, event.target.value);
  };

  useEffect(() => {
    const submitStatus =
      selectedStatus &&
      selectedStatus.map((item) => {
        return item === "Active" ? 1 : 0;
      });

    async function fetchHospital() {
      try {
        const checkLabs = await axios.post(
          Global.base_url + "/lab/check/privileges",
          null,
          config
        );
        // console.log(response);

        if (checkLabs.status === 200) {
          // console.log("test checkLabs: ", checkLabs);
          setLabAccess(checkLabs.data);
          setLabPackageAccess(
            _.some(checkLabs.data.privileges, ["privilege_name", "LAB PACKAGE"])
          );
          setLabTestAccess(
            _.some(checkLabs.data.privileges, ["privilege_name", "LAB TEST"])
          );
          if (
            _.some(checkLabs.data.privileges, ["privilege_name", "VIEW LABS"])
          ) {
            // console.log("dummycheck");
            try {
              const labsResponse = await axios.post(
                Global.base_url + "/lab",
                {
                  currentPage: page + 1,
                  pageSize: rowsPerPage,
                  search: search,
                  cities: selectedCities.length ? selectedCities : [],
                  status: submitStatus.length ? submitStatus : [],
                },
                config
              );

              if (labsResponse.status === 200) {
                // if (i === 0) {

                setHospitals(labsResponse.data.data);

                let sortedStatus = Object.keys(
                  labsResponse.data.filter.status
                ).map((item) => {
                  return {
                    name: item,
                  };
                });

                let sortedCities = labsResponse.data.filter.cities.map(
                  (item) => {
                    return {
                      name: item.city,
                    };
                  }
                );

                setFilterData({
                  status: sortedStatus,
                  cities: sortedCities,
                });
                setPaginationData(labsResponse.data.pagination);
                setPage(labsResponse.data.pagination.currentPage - 1);
                setRowsPerPage(labsResponse.data.pagination.pageSize);
              }
            } catch (error) {
              setLoading(false);
              if (error.response) {
                if (error.response.status === 401) {
                  return toast.error("Unable to get hospitals");
                }
                if (error.response.status === 500) {
                  // console.log("admin product error", error);
                  // setLoading(false);
                  return toast.error("Internal server error");
                }
              }
            }
          }

          return setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          if (error.response.status === 401) {
            return toast.error("Unable to get hospital access");
          }
          if (error.response.status === 500) {
            return toast.error("Internal server error");
          }
        }
      }
    }
    fetchHospital();
  }, [refresh]);

  // console.log("acssssssssscgsahcshagfshgafshgafsh:", [
  //   labPackageAccess,
  //   labTestAccess,
  // ]);
  // const classfilter=open?"d-flex flex-column "
  const rowdataAlign = { verticalAlign: "middle" };

  const getLab = async (pageData, rowsPerPageData) => {
    const submitStatus = selectedStatus.map((item) => {
      return item === "Active" ? 1 : 0;
    });

    try {
      const response = await axios.post(
        Global.base_url + "/lab",
        {
          currentPage: pageData + 1,
          pageSize: rowsPerPageData,
          search: search,
          cities: selectedCities.length ? selectedCities : [],
          status: submitStatus.length ? submitStatus : [],
        },
        config
      );
      // console.log(response);

      if (response.status === 200) {
        // console.log("get test data", response.data);

        setHospitals(response.data.data);
        setPaginationData(response.data.pagination);
        setPage(response.data.pagination.currentPage - 1);
        setRowsPerPage(response.data.pagination.pageSize);
        setAnchorEl(null);

        let sortedStatus = Object.keys(response.data.filter.status).map(
          (item) => {
            return {
              name: item,
            };
          }
        );

        let sortedCities = response.data.filter.cities.map((item) => {
          return {
            name: item.city,
          };
        });

        setFilterData({
          status: sortedStatus,
          cities: sortedCities,
        });
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          return toast.error("Unable to get packages");
        }
        if (error.response.status === 500) {
          return toast.error("Internal server error");
        }
      }
    }
  };

  return (
    <>
      {loading ? (
        <div className="center__items" style={{ marginTop: "50px" }}>
          <Loader type="TailSpin" color="#1565d8" height={45} width={45} />
        </div>
      ) : (
        <div style={{ width: "100%" }}>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={true}
            // newestOnTop={false}
            closeOnClick
            rtl={false}
          />
          <DeleteModal
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            selectedData={editHospital.data.lab_id}
            refresh={setRefresh}
            apiUrl={"/lab/delete"}
            name={"Lab"}
            // id={"category_id"}
          />

          {/* <MyVerticallyCenteredModal
            editProduct={editProduct}
            initialValues={initialValues}
            setRefresh={setRefresh}
            handleModal={props.handleModal}
            setEdit={setEdit}
            // modalStatus={props.modalStatus}
            
          /> */}
          <section className="filter-section testreport">
            <div className="sectionHeader p-3">
              <h2 className="hkBoldFontr" style={{ color: "#161616" }}>
                Hospitals
              </h2>
              <p className="mediumFont mt-2" style={{ color: "#515151" }}>
                {/* Lorem, ipsum dolor sit amet consectetur adipisicing elit. */}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-end  flex-md-row  mr-0 pt-2 px-0 pb-0">
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                  //   border: showFilter ? "1px solid #c3cad9" : 0,
                  borderLeft: "none",
                  borderBottom: "none",
                }}
                className="search__testcontainer"
                // id={open ? "searchTransition" : "searchStatic"}
              >
                <input
                  type="text"
                  name="search"
                  id={"search__input"}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search ID, Name, Price"
                  onKeyDown={(e) => {
                    // detects Enter key or numberpad enter key
                    if (e.code === "Enter") {
                      getLab(page, rowsPerPage);
                    }
                  }}
                />
              </div>
              <div
                className="filter__container"
                style={{ backgroundColor: open ? "#F3F3F3" : "#fff" }}
              >
                <div
                  className="filter__icon p-3"
                  onClick={filterClick}
                  style={{ backgroundColor: open ? "#F3F3F3" : "#fff" }}
                >
                  {selectedCities.length + selectedStatus.length !== 0 ? (
                    <Badge
                      badgeContent={
                        selectedCities.length + selectedStatus.length
                      }
                      color="primary"
                    >
                      <IconContext.Provider
                        value={{
                          color: "#333",
                          size: "25px",
                        }}
                      >
                        <BsSliders />
                      </IconContext.Provider>
                    </Badge>
                  ) : (
                    <IconContext.Provider
                      value={{
                        color: "#333",
                        size: "25px",
                      }}
                    >
                      <BsSliders />
                    </IconContext.Provider>
                  )}
                </div>

                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={filterClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    style: {
                      // width: "45%",
                      backgroundColor: "#f3f3f3",
                      // display: "flex",
                      // justifyContent: 'space-between'
                    },
                  }}
                >
                  <div className="pop__container">
                    {selectedCities.length + selectedStatus.length ? (
                      <div className="selected__items px-4 pt-4 d-flex align-items-center semiFont">
                        <div className="batch__item d-flex align-items-center">
                          <p className="mr-2 mt-1">
                            {selectedCities.length + selectedStatus.length}
                          </p>
                          <div
                            className="icons"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedCities([]);
                              setSelectedStatus([]);
                            }}
                          >
                            <IconContext.Provider
                              value={{
                                color: "#fff",
                                size: "20px",
                              }}
                            >
                              <CgClose />
                            </IconContext.Provider>
                          </div>
                        </div>
                        <p className="ml-2">Filteres are selected</p>
                      </div>
                    ) : null}

                    <div className="row px-4 pb-4 pt-4 justify-content-lg-between">
                      <div className="col">
                        <p className="semiFont pop__header">Cities</p>
                        <div className="filter__items mt-2 d-flex flex-column filter__scroll">
                          {filterData &&
                            filterData.cities &&
                            filterData.cities.map((item, i) => {
                              return (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        selectedCities.includes(item.name)
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        const { checked } = e.target;
                                        if (checked) {
                                          setSelectedCities([
                                            ...selectedCities,
                                            item.name,
                                          ]);
                                        } else {
                                          setSelectedCities(
                                            selectedCities &&
                                              selectedCities.filter((list) => {
                                                return item.name !== list;
                                              })
                                          );
                                        }
                                      }}
                                      name={item.name}
                                      color="primary"
                                    />
                                  }
                                  label={item.name}
                                />
                              );
                            })}
                        </div>
                      </div>
                      <Divider orientation="vertical" flexItem />
                      <div className="col">
                        <p className="semiFont pop__header">Status</p>
                        <div className="filter__items mt-2 d-flex flex-column">
                          {filterData &&
                            filterData.status &&
                            filterData.status.map((item, i) => {
                              return (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        selectedStatus.includes(item.name)
                                          ? true
                                          : false
                                      }
                                      onChange={(e) => {
                                        const { checked } = e.target;
                                        if (checked) {
                                          setSelectedStatus([
                                            ...selectedStatus,
                                            item.name,
                                          ]);
                                        } else {
                                          setSelectedStatus(
                                            selectedStatus &&
                                              selectedStatus.filter((list) => {
                                                return item.name !== list;
                                              })
                                          );
                                        }
                                      }}
                                      name={item.name}
                                      color="primary"
                                    />
                                  }
                                  label={item.name}
                                />
                              );
                            })}
                        </div>
                      </div>
                    </div>
                    <div className="carbon__buttoncontainer">
                      {/* {location.state.editable ? ( */}
                      <Button
                        variant="contained"
                        className="carbon__secondarybtn carbon__btn"
                        id="admin-reportview-download-btn"
                        style={{
                          //   padding: "25px ",
                          color: "#fff",
                          //   border: "1px solid #1565d8",
                          //   marginRight: "15px",
                        }}
                        onClick={() => {
                          setSelectedStatus([]);
                          setSelectedCities([]);
                        }}
                      >
                        <p>Reset Filter</p>
                      </Button>
                      {/* ) : null} */}

                      <Button
                        variant="contained"
                        className="carbon__primarybtn carbon__btn"
                        id="admin-reportview-download-btn"
                        style={{
                          //   padding: "10px 25px",

                          color: "#fff",
                        }}
                        onClick={() => getLab(page, rowsPerPage)}
                      >
                        <p className="carbon__text">Apply Filter</p>
                        {/* Yes */}
                      </Button>
                    </div>
                  </div>
                </Popover>
                {/* </> */}
              </div>
              {labAccess &&
              _.some(labAccess.privileges, ["privilege_name", "ADD LABS"]) ? (
                <Button
                  variant="contained"
                  color="secondary"
                  // className="primary__button"
                  type="submit"
                  startIcon={
                    <IconContext.Provider
                      value={{
                        color: "#fff",
                        size: "25px",
                      }}
                    >
                      <MdAdd />
                    </IconContext.Provider>
                  }
                  className={[classes.rootAbsolute, "primary__button"]}
                  onClick={() => {
                    // setHospital({
                    //   data: "",
                    //   index: "",
                    // });
                    // setShowEditModal(true);
                    history.push({
                      pathname: "/admin/lab-view",
                      state: {
                        editable: false,
                        data: null,
                      },
                    });
                  }}
                >
                  Add Hospitals
                </Button>
              ) : null}
            </div>
          </section>
          <section
            className="admin-product-filter-section table-responsive fixHeader
"
          >
            <table
              className="table  text-center  admin-product_usertable mb-0"
              style={{
                backgroundColor: "white",
              }}
              id="bill-table"
            >
              <thead>
                <tr
                  id="admin-product-row"
                  style={{ border: "none", backgroundColor: "#E0E0E0" }}
                >
                  <th scope="col" className="admin-product-row_table-header">
                    Id
                  </th>
                  <th scope="col" className="admin-product-row-table-header">
                    Name
                  </th>
                  <th
                    scope="col"
                    className="admin-product-row-table-header admin-product-row-price-col"
                  >
                    Country
                  </th>
                  <th
                    scope="col"
                    className="admin-product-row-table-header  admin-product-row-price-col"
                  >
                    State
                  </th>
                  <th
                    scope="col"
                    className="admin-product-row-table-header   admin-product-row-status-col"
                  >
                    City
                  </th>
                  <th
                    scope="col"
                    className="admin-product-row-table-header  admin-product-row-status-col"
                  >
                    Status
                  </th>
                  {labAccess &&
                  _.some(labAccess.privileges, [
                    "privilege_name",
                    "EDIT LABS",
                  ]) ? (
                    <th
                      scope="col"
                      className="admin-product-row-action-col admin-product-row-table-header"
                    ></th>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {hospitalList.length > 0 ? (
                  hospitalList.map((data, i) => {
                    if (i > rowsPerPage - 1) {
                      return;
                    }
                    const color = data.status === 1 ? "#03A33B" : "red";

                    //   const borderLeft = `5px solid ${color}`;
                    const borderBottom = `1px solid #B3CDFF`;
                    // const font = "mediumFont";

                    return (
                      <>
                        <tr
                          key={data.lab_id + Math.random()}
                          style={{
                            //   borderLeft,
                            borderBottom,
                            backgroundColor: "white",
                          }}
                          className="admin-product-row-table-row-hover "
                        >
                          <td
                            scope="row"
                            id="admin-product-rd"
                            className="admin-product-row-table-row-data mediumFont"
                            style={rowdataAlign}
                          >
                            <p
                              data-toggle="collapse"
                              data-target={`#accordion` + i}
                              className="clickable"
                              id="button-open"
                              // style={{ display: "none" }}
                            >
                              <IconContext.Provider
                                value={{
                                  color: "#4059E2",
                                  size: "25px",
                                  style: { marginBottom: "3px" },
                                }}
                              >
                                <IoMdAddCircle className="toggle-row-icon" />
                              </IconContext.Provider>
                            </p>{" "}
                            HID{data.lab_id}
                          </td>
                          <td
                            className="admin-product-row-table-row-data mediumFont"
                            style={rowdataAlign}
                          >
                            {" "}
                            {data.lab_name}
                          </td>
                          <td
                            className="admin-product-row-table-row-data admin-product-row-price-col mediumFont"
                            style={rowdataAlign}
                          >
                            {data.country}
                          </td>
                          <td
                            className="admin-product-row-table-row-data admin-product-row-price-col mediumFont"
                            style={rowdataAlign}
                          >
                            {data.state}
                          </td>
                          <td
                            className="admin-product-row-table-row-data admin-product-row-status-col mediumFont"
                            style={rowdataAlign}
                          >
                            {data.city}
                          </td>
                          <td
                            className="admin-product-row-table-row-data admin-product-row-status-col mediumFont"
                            style={{ color, ...rowdataAlign }}
                          >
                            {data.status ? "Active" : "Inactive"}
                          </td>
                          {/* {labAccess &&
                          _.some(labAccess.privileges, [
                            "privilege_name",
                            "EDIT LABS",
                          ]) ? (
                            <td
                              className="admin-product-row-action-col admin-product-row-table-row-data "
                              style={rowdataAlign}
                            >
                              <Button
                                key={"view" + i}
                                variant="contained"
                                color="default"
                                className={"admin-product-Filter__button mr-2"}
                                // startIcon={<AiOutlineCloudDownload color="#2C3E50" />}
                                style={{ padding: "8px 20px" }}
                                onClick={() => {
                                  console.log("datassss", data);
                                  setHospital({
                                    data: data,
                                    index: i,
                                  });
                                  setShowEditModal(true);
                                }}
                                startIcon={<BiEditAlt />}
                              >
                                Edit
                              </Button>
                            </td>
                          ) : null} */}

                          {(labAccess &&
                            _.some(labAccess.privileges, [
                              "privilege_name",
                              "EDIT LABS",
                            ])) ||
                          _.some(labAccess.privileges, [
                            "privilege_name",
                            "DELETE LABS",
                          ]) ? (
                            <td
                              className="admin-product-row-action-col py-3"
                              colSpan={1.5}
                              style={rowdataAlign}
                            >
                              <div className="iconButtons__container">
                                {_.some(labAccess.privileges, [
                                  "privilege_name",
                                  "EDIT LABS",
                                ]) ? (
                                  <Tooltip
                                    title={"Edit"}
                                    placement="top-center"
                                  >
                                    <IconButton
                                      className="edit__IconButton"
                                      onClick={() => {
                                        history.push({
                                          pathname: "/admin/lab-view",
                                          state: {
                                            editable: true,
                                            data: data,
                                          },
                                        });
                                      }}
                                    >
                                      <IconContext.Provider
                                        value={{
                                          color: "#1565d8",
                                          size: "30px",
                                        }}
                                      >
                                        <BiEditAlt />
                                      </IconContext.Provider>
                                    </IconButton>
                                  </Tooltip>
                                ) : null}
                                {_.some(labAccess.privileges, [
                                  "privilege_name",
                                  "DELETE LABS",
                                ]) ? (
                                  <Tooltip
                                    title={"Remove"}
                                    placement="top-center"
                                  >
                                    <IconButton
                                      className="delete__IconButton"
                                      onClick={() => {
                                        setHospital({
                                          data: data,
                                          index: i,
                                        });
                                        setDeleteModal(true);
                                        // deleteReport(
                                        //   uploadedReports.combined[0]
                                        // );
                                      }}
                                    >
                                      <IconContext.Provider
                                        value={{
                                          color: "#cc0000",
                                          size: "30px",
                                        }}
                                      >
                                        <AiOutlineDelete />
                                      </IconContext.Provider>
                                    </IconButton>
                                  </Tooltip>
                                ) : null}
                              </div>
                            </td>
                          ) : null}
                        </tr>
                        <tr
                          id={"accordion" + i}
                          className="collapse  admin-product-hided-row"
                          key={data.lab_id + Math.random()}
                        >
                          <td colSpan="6" style={rowdataAlign}>
                            <ul className="admin-product-row-table-hide-list text-left ">
                              <li
                                key={i + data.lab_id + i + Math.random()}
                                style={{
                                  // borderBottom: "1px solid #B3CDFF",
                                  padding: "10px",
                                }}
                                className="admin-product-row-hided-col-price"
                              >
                                <div className="row justify-content-start ml-3">
                                  <div className="col-6  text-center">
                                    Country:
                                  </div>
                                  <div className="col-6  text-left">
                                    {data.country}
                                  </div>
                                </div>
                              </li>
                              <li
                                key={i + data.lab_id + i + Math.random()}
                                style={{
                                  // borderBottom: "1px solid #B3CDFF",
                                  padding: "10px",
                                }}
                                className="admin-product-row-hided-col-price"
                              >
                                <div className="row justify-content-start ml-3">
                                  <div className="col-6  text-center">
                                    State:
                                  </div>
                                  <div className="col-6  text-left">
                                    {data.state}
                                  </div>
                                </div>
                              </li>
                              <li
                                key={i + data.lab_id + i + Math.random()}
                                style={{
                                  // borderBottom: "1px solid #B3CDFF",
                                  padding: "10px",
                                }}
                                // className="admin-product-row-hided-col-price"
                              >
                                <div className="row justify-content-start ml-3">
                                  <div className="col-6  text-center">
                                    City:
                                  </div>
                                  <div className="col-6  text-left">
                                    {data.city}
                                  </div>
                                </div>
                              </li>
                              <li
                                key={data.lab_id + Math.random()}
                                style={{
                                  // borderBottom: "1px solid #B3CDFF",
                                  padding: "10px",
                                }}
                              >
                                <div className="row justify-content-start ml-3">
                                  <div className="col-6  text-center">
                                    Status:
                                  </div>
                                  <div
                                    className="col-6  text-left"
                                    style={{ color }}
                                  >
                                    {data.status ? "Active" : "Inactive"}
                                  </div>
                                </div>
                              </li>
                              {(labAccess &&
                                _.some(labAccess.privileges, [
                                  "privilege_name",
                                  "EDIT LABS",
                                ])) ||
                              (labAccess &&
                                _.some(labAccess.privileges, [
                                  "privilege_name",
                                  "DELETE LABS",
                                ])) ? (
                                <li
                                  key={data.lab_id + Math.random()}
                                  style={{
                                    // borderBottom: "1px solid #B3CDFF",
                                    padding: "10px",
                                  }}
                                >
                                  <div
                                    className="row justify-content-center mt-2 ml-3"
                                    style={{ gap: "10px" }}
                                  >
                                    <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3  text-center iconButtons__container">
                                      {_.some(labAccess.privileges, [
                                        "privilege_name",
                                        "EDIT LABS",
                                      ]) ? (
                                        <Tooltip
                                          title={"Edit"}
                                          placement="top-center"
                                        >
                                          <IconButton
                                            className="edit__IconButton"
                                            onClick={() => {
                                              history.push({
                                                pathname: "/admin/lab-view",
                                                state: {
                                                  editable: true,
                                                  data: data,
                                                },
                                              });
                                            }}
                                          >
                                            <IconContext.Provider
                                              value={{
                                                color: "#1565d8",
                                                size: "30px",
                                              }}
                                            >
                                              <BiEditAlt />
                                            </IconContext.Provider>
                                          </IconButton>
                                        </Tooltip>
                                      ) : null}
                                      {_.some(labAccess.privileges, [
                                        "privilege_name",
                                        "DELETE LABS",
                                      ]) ? (
                                        <Tooltip
                                          title={"Remove"}
                                          placement="top-center"
                                        >
                                          <IconButton
                                            className="delete__IconButton"
                                            onClick={() => {
                                              setHospital({
                                                data: data,
                                                index: i,
                                              });
                                              setDeleteModal(true);
                                              // deleteReport(
                                              //   uploadedReports.combined[0]
                                              // );
                                            }}
                                          >
                                            <IconContext.Provider
                                              value={{
                                                color: "#cc0000",
                                                size: "30px",
                                              }}
                                            >
                                              <AiOutlineDelete />
                                            </IconContext.Provider>
                                          </IconButton>
                                        </Tooltip>
                                      ) : null}
                                    </div>
                                  </div>
                                </li>
                              ) : null}
                            </ul>
                          </td>
                        </tr>
                      </>
                    );
                  })
                ) : (
                  <div
                    className="center__items p-5"
                    style={{ flexDirection: "column" }}
                  >
                    <img src={emptyLabs} alt="empty-labs" />
                    <p
                      style={{
                        color: "#D2D2D2",
                        padding: "20px",
                        fontSize: "20px",
                        fontFamily: "mediumFont",
                      }}
                    >
                      {labAccess &&
                      _.some(labAccess.privileges, [
                        "privilege_name",
                        "VIEW LABS",
                      ])
                        ? "Labs not found..."
                        : "You don't have access"}
                    </p>
                  </div>
                )}
              </tbody>
            </table>
          </section>
          {paginationData && paginationData.totalData > 5 ? (
            <div className="d-flex flex-row align-items-center justify-content-end mb-4">
              <TablePagination
                component="div"
                count={paginationData ? paginationData.totalData : 0}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 50]}
              />
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default Labs;
